/**
 * @generated SignedSource<<718f44a9e92e1d7dd77b78909d0471cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectHeader_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_inner_project">;
  readonly " $fragmentType": "ProjectHeader_project";
};
export type ProjectHeader_project$key = {
  readonly " $data"?: ProjectHeader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ProjectHeader_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectHeader_inner_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "78893912e046c1d6733f1058dcb592a0";

export default node;
